import { render, staticRenderFns } from "./BookingId.vue?vue&type=template&id=a0f790f2&scoped=true&"
import script from "./BookingId.vue?vue&type=script&lang=js&"
export * from "./BookingId.vue?vue&type=script&lang=js&"
import style0 from "./BookingId.vue?vue&type=style&index=0&id=a0f790f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f790f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VMenu})
